import React, { useContext, useState, useEffect } from 'react'
// import { loadingMiniContext } from '../../commonLib/lodingMiniContext';
import LoadingContainer from '../../../controls/LoadingContainer';
import { getLoginInfo } from '../../../../configurations/auth/getLoginInfo';
import { setLoginInfo } from '../../../../configurations/auth/setLoginInfo';
import { BASE_URL, FEMALE_DR_AVATAR, MALE_DR_AVATAR, SIDE_AVATAR, WATERMARK_AVATAR } from '../../../../configurations/initUrls';
import { useToast } from '../../../controls/Toast/ToastService';
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5';
import { MdErrorOutline } from 'react-icons/md';
import { UploadWaterMark } from '../../../../configurations/crud/applicationUserCrud';
import { WaterMarkUploader } from '../../../../configurations/commonlib/WaterMarkUploader';
import useGlobalLoader from '../../../../configurations/useGlobalLoader';

export function UploadWaterMarks() {
    const { start, end } = useGlobalLoader()
    const [isLoadingMini, setIsLoadingMini] = useState()
    const [isLoadingLocal, setIsLoadingLocal] = useState(false)
    const userData = getLoginInfo()
    const [photo, setPhoto] = useState("")
    const toast = useToast()

    const SetPhotoH = (image) => {
        setPhoto(image)
    }
    useEffect(() => {
        if (photo)
            SaveHeaderPhoto()
    }, [photo])
    const SaveHeaderPhoto = () => {
        setIsLoadingMini(true);
        setIsLoadingLocal(true);
        start()
        const formData = new FormData()

        formData.append('id', userData.id)
        formData.append('file', photo)
        UploadWaterMark(formData)
            .then(res => {
                if (res.data.succeeded) {
                    setIsLoadingMini(false);
                    setIsLoadingLocal(false);
                    end()
                    toast.open("Updated successfully", <IoCheckmarkDoneCircleOutline />, "success")
                    UpdateLocal(res.data.message)
                    window.location.reload()
                }
                else {
                    setIsLoadingMini(false)
                    setIsLoadingLocal(false);
                    end()
                    toast.open("Server Error /Invalid Try.", <MdErrorOutline />, 'error')
                }
            })
            .catch(error => {
                setIsLoadingMini(false);
                setIsLoadingLocal(false);
                end()
                toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000)
            })
    }

    const UpdateLocal = (url) => {
        let data = userData;
        data = { ...data, isWaterMark: 1, waterMarkUrl: url }
        setLoginInfo(JSON.stringify(data))
    }
    return (
        <>
            <div className="row">
                <div className="col-md-4">
                </div>
                <div className="col-md-4">
                    <div class="form-group">
                        <div class="col-xs-12">
                            <WaterMarkUploader initImage={userData.isWaterMark == 1 ? BASE_URL + userData.waterMarkUrl : WATERMARK_AVATAR} SetImage={SetPhotoH} />
                        </div>
                    </div>
                </div>
            </div>

            {photo && <div class="clearfix form-actions mt-2">
                <div class="pull-right">
                    {isLoadingLocal &&
                        <LoadingContainer text={"Uploading WaterMark..."} />
                        // :
                        // <button type="submit" expand="block" onClick={SavePhoto} disabled={!photo} class="bg-indigo-800 text-white px-4 py-2 rounded-lg hover:bg-blue-900 transition-colors duration-300 ring ring-gray-300 hover:ring-indigo-300">
                        //     Upload
                        // </button>
                    }
                </div>
            </div>}
        </>

    )
}

